declare namespace $ {

	export class $shm_showcase_demo_tree extends $shm_tree {
		items( id: any): readonly(any)[]
		roots( ): readonly(any)[]
		children( id: any): ReturnType< $shm_showcase_demo_tree['items'] >
	}
	
}

//# sourceMappingURL=tree.view.tree.d.ts.map